import React from 'react';

import { connect } from 'react-redux';

import { Actions as FSSACTIONS } from '../../store/actions/fssReportActions';

import { ArrowDownTrayIcon } from '@heroicons/react/20/solid';
import Spinner from '../common/Spinner';

const DownloadForms = ({
    downloadEmployeeForm,
    formsDownloading,
    agreementId,
    salarySettingId,
    adjustmentId,
    taxSettingId,
    jurisdiction,
    formType
}) => {

    const forms = [
        {
            form: 'Jobs Plus Employment',
            name: 'Engagement Form',
            jurisdiction: 'MT',
            formType: 'salary'
        },
        {
            form: 'Jobs Plus Termination',
            name: 'Termination Form',
            jurisdiction: 'MT',
            formType: 'salary'
        },
        {
            form: 'FS4',
            jurisdiction: 'MT',
            formType: 'tax'
        },
        {
            form: 'Direct Attachment',
            name: 'Report',
            jurisdiction: 'UK',
            formType: 'direct attachments'
        },
        {
            form: 'Direct Attachments Full',
            name: 'Full Report',
            jurisdiction: 'UK',
            formType: 'direct attachments full'
        },
    ]?.filter(item => (item.jurisdiction == jurisdiction) && (item.formType === formType?.toLowerCase()))

    if (forms.length == 0) return null

    return (
            <div className='btn-group pull-right' style={{ marginTop: 5 }}>
                {forms.map(item => {
                    const downloading = formsDownloading?.[item.form]
                    return (
                        <button
                            type="button"
                            key={item.form}
                            disabled={downloading}
                            onClick={() => { downloadEmployeeForm({ agreementId, salarySettingId, taxSettingId, adjustmentId, form: item.form }) }}
                            className='btn btn-default'>
                            {downloading ?
                                <Spinner
                                    style={{ float: 'left' }}
                                    className="animate-spin -ml-1 mr-3 h-7 w-7 "
                                />
                                :
                                <ArrowDownTrayIcon style={{ height: "1.5em", float: "left" }} />
                            }
                            <div style={{ float: "left", paddingLeft: 5 }}>{item.name || item.form}</div>
                        </button>
                    )
                })}
            </div>
    );
};


const mapStateToProps = (state, ownProps) => {
    return {
        formsDownloading: state.fssDownloading,
        jurisdiction: state.company?.settings?.jurisdiction
    };
};

const mapDispatchToProps = (dispatch) => ({
    downloadEmployeeForm: (params) => dispatch(FSSACTIONS.downloadEmployeeForm(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadForms);

